import { render, staticRenderFns } from "./issueregistview.vue?vue&type=template&id=23f0c3b8&scoped=true&"
import script from "./issueregistview.vue?vue&type=script&lang=js&"
export * from "./issueregistview.vue?vue&type=script&lang=js&"
import style0 from "./issueregistview.vue?vue&type=style&index=0&id=23f0c3b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0c3b8",
  null
  
)

export default component.exports